import React, { lazy, Suspense } from 'react';
import config from 'config/env';
import { useDispatch } from 'react-redux';
import { Box, IconButton, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import useHandleTrackEvent from '@/hooks/useHandleTrackEvent';
import { setWalkthroughsListOpen } from '@/redux/slices/productTourSlice';

/**
 * Dev-only, and lazy for the same reason `Page.js` lazies the theme
 * configurator: a static import would ship the 25-family font catalogue to
 * every production user to back a control none of them can see.
 */
const SidebarTypeface = lazy(() => import('@/components/SidebarTypeface'));

/**
 * The app-level utilities in the topbar's top-right corner: the typeface
 * picker (dev-only design tooling) and the walkthrough launcher (user-facing
 * help, so it renders in every environment). They used to sit on the
 * sidebar's account row.
 */
const TopbarUtilities = () => {
  const dispatch = useDispatch();
  const handleTrackEvent = useHandleTrackEvent();
  const showDevThemeControls = config.isLocal || config.isDevelopment;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {showDevThemeControls ? (
        <Suspense fallback={null}>
          <SidebarTypeface inTopbar />
        </Suspense>
      ) : null}
      <Tooltip title="Help Walkthroughs" arrow placement="bottom">
        <IconButton
          size="small"
          data-tour="topbar-walkthroughs"
          data-trackid="open_walkthroughs_list_dialog"
          aria-label="Help Walkthroughs"
          onClick={(e) => {
            handleTrackEvent(e, 'open_walkthroughs_list_dialog');
            dispatch(setWalkthroughsListOpen(true));
          }}
          sx={{ flexShrink: 0, color: 'text.secondary' }}
        >
          <HelpOutline sx={{ fontSize: 20 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default TopbarUtilities;
